import React from 'react';
import api from './../../../services/api';
import { user_token } from '../../../services/Auth';
import GetAge from './GetAge';

//import da API
import { organizer } from './../../../services/api';
let apiOrganizer = new organizer();

var token = localStorage.getItem(user_token);

export default class GetUser extends React.Component {
  state = {
    paciente: []
  }

  componentDidMount() {
    //api.get(`/user/${this.props.user_id}`, { headers: { 'x-access-token': token } })
    apiOrganizer.getUser(this.props.user_id)
      .then(res => {
        const paciente = res.data;
        this.setState({ paciente });
      })
  }

  render() {
    return (
      <ul>
        {this.state.paciente.map(details =>
          <>
            <p id="RI-Title-Cadastro-Paciente" >ID do(a) Paciente: </p><p>{details.numericID}</p>
            <p id="RI-Title-Cadastro-Paciente" >Nome do(a) Paciente: </p><p>{details.name}</p>
            {details.user_type === "Paciente" ? <> <p id="RI-Title-Cadastro-Paciente">Tipo de paciente:</p><p>Paciente da instituição</p></> :
              details.user_type === "Funcionario" ? <> <p id="RI-Title-Cadastro-Paciente">Tipo de paciente:</p><p>Funcionário da instituição</p></> :
                null}
            <p id="RI-Title-Cadastro-Paciente" >Data de Nascimento do(a) Paciente: </p><p>{details.birth}</p>
            <p id="RI-Title-Cadastro-Paciente" >CPF do(a) Paciente: </p><p>{details.cpf}</p>
            <p id="RI-Title-Cadastro-Paciente" >Idade do(a) Paciente: </p><p><GetAge birth={details.birth} /> anos</p>
            <p id="RI-Title-Cadastro-Paciente" >Genêro do(a) Paciente: </p><p>{details.gender}</p>
            <p id="RI-Title-Cadastro-Paciente" >Endereço do(a) Paciente: </p><p>{details.adress}</p>
          </>)}
      </ul>
    )
  }
}